import React from 'react';
import './sub1.css'
import { Link } from "react-router-dom";
const Sub1 = () => {
    return (
        <div>
            
        <div className="img_container">
            <img src="images/cos1.jpg" alt="반지만들기2인" />
        </div>
        <div className="container">
        <div className="tag">
            <ul>
                <li><a href="#">예약필수</a></li>   
                <li><a href="#">공휴일영업</a></li>
                <li><a href="#">일요일휴무</a></li>
            </ul>
        </div>
        <div className="textbox">
            <div className="point">반지만들기 건대점</div>
            <h1>반지만들기2인<span>(넓이 2.5mm 기준)</span></h1>
            <div className="point">순은(99.99%)을 사용하여 서로간의 반지를 만들 수 있습니다. </div>
        </div>
        <div className="list">
            <div className="title">진행과정</div>
            <ol>
                <li>1. '신청서 작성' 및 '디자인 선택'</li>
                <li>2. '사이즈 체크' 및 '은판 재단'</li>
                <li>3. '이니셜 작업'</li>
                <li>4. '사포 작업'</li>
                <li>5. '열처리'</li>
                <li>6. '땜작업'</li>
                <li>7. '망치 작업'</li>
                <li>8. '사포 작업'</li>
                <li>9. '핸드피스 작업'</li>
                <li>10. '세팅 작업' 및 마무리</li>
            </ol>
        </div>
        <div className="price">60,000원</div>
        <div className="price_main">
            <p className="num">10개 남음</p>
            <div className="price_deal"><span>17%</span> 50,000원</div>
          </div>
          <div className="line"></div>
          <div className="info">
            <h2>반지만들기카페 건대점</h2>
            <p>영업시간<span>09:00 ~ 18:00</span></p>
            <p>휴무일<span>토,일 공휴일</span></p>
          </div>
          <div className="error">
            <h2>주의사항</h2>
            <div className="er_title">타 이벤트와 <span>중복 할인은 불가능</span>합니다.</div>
            <p>다른 곳에서 제공하는 할인 이벤트와 중복 사용이 불가능합니다.</p>
          </div>
<div className="gomain">
    <Link to="/">메인으로</Link>
</div>
</div>
        </div>
    );
};

export default Sub1;